var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlzLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_20732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10412 14.4931C7.28733 7.32715 5.01501 1.90625 5.01501 1.90625C5.01501 1.90625 10.8518 8.55243 7.91111 17.2036C5.19323 25.1122 7.15367 29.9019 7.15367 29.9019C7.15367 29.9019 1.89613 25.1864 5.10412 14.4931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00081 23.2564C10.2286 19.6919 14.6841 19.432 17.1347 11.5234C17.1347 11.5234 17.1347 11.5234 17.1792 11.5234C17.5357 20.9915 14.3722 22.6623 11.6098 25.0014C9.47114 26.7837 8.40181 28.7515 8.00081 29.6798C7.55526 30.6822 7.9117 28.4174 8.17903 27.4149C10.184 20.9915 15.4416 22.0682 16.6 14.4567C16.6446 14.1596 16.6891 13.8997 16.7337 13.6027C16.6891 13.9369 16.6446 14.1596 16.6 14.4567C14.6841 22.9593 8.53548 19.9518 7.10971 29.6798C7.06515 30.9793 6.2186 26.1525 8.00081 23.2564Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_20732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlzLogoSmall);
export default __webpack_public_path__ + "static/media/AlzLogoSmall.3335bfd16ed83c5ab2b228f6ba263b1d.svg";
export { ForwardRef as ReactComponent };